<div class="bulb-create-new-link-dialog">
    <svg-icon
        key="times"
        fontSize="1em"
        class="bulb-close-dialog"
        (click)="closeCreateNewLinkDialog()">
    </svg-icon>
    <svg-icon
        key="exclamation-triangle"
        fontSize="3em"
        class="bulb-exclamation-triangle">
    </svg-icon>

    <h1 class="bulb-create-new-link-title" transloco="shareLink.createNewLink.title"></h1>
    <p class="bulb-create-link-description" transloco="shareLink.createNewLink.description"></p>

    <div class="button-container">
        <button
            class="bulb-new-link-btns bulb-cancel-btn"
            (click)="closeCreateNewLinkDialog()"
        >
            <span transloco="sharePanel.cancel"></span>
        </button>

        <button
            class="bulb-new-link-btns bulb-confirm-new-link-btn"
            (click)="confirmCreateNewLink()"
        >
            <span transloco="sharePanel.confirmButton"></span>
        </button>
    </div>
</div>
